import AiAnalysisResult from "./AiAnalysisResult";
import RelatedKeyword from "./RelatedKeyword";
import DegreeSection from "./DegreeSection";
import MeasurementResult from "./MeasurementResult";
import styled from "styled-components";

const ScoreList = styled.ul`
    li {
        margin: 0 10px !important; 
        width: 70px !important;

        &:first-child {
            padding-left: 20px;
        }

        &:last-child {
            width: fit-content !important;
        }
    }
    li ~ li {
        padding-left: 10px !important;
    }
`;
export default function DetailSpeckle({data, img}) {
    return (
        <MeasurementResult type="색소스팟" description="일부 피부가 주변 피부보다 어두워 보이는 현상으로, 이는 멜라닌 색소의 증가로 인해 발생합니다. 대부분의 멜라닌 증가는 햇볕에 노출됨에 따라 발생하며, 이러한 잡티는 피부 무결성과 관련이 있으며 올바른 피부 톤을 유지하는 데 중요합니다." score={data.score}>
            <div className="row-wrap">
                <div className="img-wrap more">
                    <div className="img-cont">
                        {
                            img.image_cross_polar_front &&
                            <img src={img.image_cross_polar_front} />
                        }
                        {
                            img.image_mark_chloasma_front &&
                            <img src={img.image_mark_chloasma_front} />
                        }
                        {
                            img.image_mark_freckles_front &&
                            <img src={img.image_mark_freckles_front} />
                        }
                        
                        {
                        img.image_mark_sk_front &&
                        <img src={img.image_mark_sk_front} />
                        }
                        {
                        img.image_mark_other_spots_front &&
                        <img src={img.image_mark_other_spots_front} />
                        }

                        <div className="caption">화이트 라이트</div>
                    </div>
                    <div className="img-cont">
                        {
                        img.image_grey_front &&
                        <img src={img.image_grey_front} />
                        }
                        {
                        img.image_mark_spot_grey_front &&
                        <img src={img.image_mark_spot_grey_front} />
                        }

                        <div className="caption">그레이 라이트</div>
                    </div>

                    <div className="img-cont">
                        {
                        img.image_brown_front &&
                        <img src={img.image_brown_front} />
                        }
                        {
                        img.image_mark_spot_brown_front &&
                        <img src={img.image_mark_spot_brown_front} />
                        }
                        <div className="caption">브라운 라이트</div>
                    </div>
                </div>

                <DegreeSection type="색소스팟" text={data.degreeText}
                    level={data.degree}
                    badge={data.analysisBadge}
                    items={[
                        {
                            value: "없음",
                            level: 1
                        },
                        {
                            value: "경도",
                            level: 2
                        },
                        {
                            value: "중간 정도",
                            level: 3
                        },
                        {
                            value: "중증 정도",
                            level: 4
                        },
                    ]}  
                    line={3}
                />
            </div>

            {
            data.count &&
            <section className="row-wrap">
                <div className="h4">색소스팟 유형</div>

                <ScoreList className="score-list">
                    <li>
                        <div className="caption">기미</div>
                        <div className="value">{data.count.chloasma}</div>
                    </li>
                    <li>
                        <div className="caption">검버섯</div>
                        <div className="value">{data.count.sk}</div>
                    </li>
                    <li>
                        <div className="caption">주근깨</div>
                        <div className="value">{data.count.freckles}</div>
                    </li>
                    <li>
                        <div className="caption">색소침착</div>
                        <div className="value">{data.count.other_spots}</div>
                    </li>
                    <li>
                        <div className="caption">후천성 진피멜라닌세포증(ADM)</div>
                        <div className="value">{data.count.adm}</div>
                    </li>
                </ScoreList>
            </section>
            }

            <div className="row-wrap grow">
                <RelatedKeyword list={data.keyword} />

                <AiAnalysisResult text={data.aiResult} hideTitle={true} line={5}/>
            </div>
        </MeasurementResult>
    )
}